import { AlmeApiBase } from '@alme/api-ts/Alme/AlmeApiBase';
import { AlmeNotificationApiBase } from '@alme/api-ts/Notification/AlmeNotificationApiBase';
import { AlmeApiSettingsBase } from '@alme/api-ts/Alme/AlmeApiSettingsBase';
import { AlmeNotificationApiSettingsBase} from '@alme/api-ts/Notification/AlmeNotificationApiSettingsBase';
import { settings } from '../settings/settings-util';
import { HttpHandlerBase } from '@alme/api-ts/HttpHandlerBase';
 
const logger = console;
const httpHandler = new HttpHandlerBase();
let almeApi = new AlmeApiBase(logger, httpHandler, new AlmeApiSettingsBase());
let almeNotificationApi = new AlmeNotificationApiBase(logger, httpHandler, new AlmeNotificationApiSettingsBase());


function initializeAlmeApi(): void{
    const apiSettings = new AlmeApiSettingsBase();
    apiSettings.AlmeApiHostname = settings.AlmeAPI.ALME_API_HOSTNAME;
    apiSettings.AlmeApiProtocol = settings.AlmeAPI.ALME_API_PROTOCOL as "https://" | "http://";
    apiSettings.AlmeApiBasePath = settings.AlmeAPI.ALME_API_BASE_PATH;
    apiSettings.AlmeApiRequestTimeout = settings.AlmeAPI.ALME_API_REQUEST_TIMEOUT;

    const notificationApiSettings = new AlmeNotificationApiSettingsBase();
    notificationApiSettings.AlmeApiHostname = settings.AlmeAPI.ALME_API_HOSTNAME;
    notificationApiSettings.AlmeApiProtocol = settings.AlmeAPI.ALME_API_PROTOCOL as "https://" | "http://";
    notificationApiSettings.AlmeApiNotificationEndpoint = settings.ExtensibleAlmeAPI.notificationsApi;
    notificationApiSettings.AlmeApiBasePath = settings.AlmeAPI.ALME_API_BASE_PATH;
    notificationApiSettings.AlmeApiRequestTimeout = settings.AlmeAPI.ALME_API_REQUEST_TIMEOUT;
    
    almeApi = new AlmeApiBase(logger, httpHandler, apiSettings);
    almeNotificationApi = new AlmeNotificationApiBase(logger, httpHandler, notificationApiSettings);
}

export {
    initializeAlmeApi,
    almeApi,
    almeNotificationApi,
    httpHandler,
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/util/alme-api.ts